import { CategoryStep } from './CategoryStep';
import useCategoryFeedbackFormHandling from '../useCategoryFeedbackFormHandling';
import { DietaryHabitsAndHealthUIConfig } from '../../../shared/CategoryStepUIConfig';
import { useFamilyMemberInterviewWizard } from './useFamilyMemberInterviewWizard';

const UiConfig = DietaryHabitsAndHealthUIConfig;

export const DietaryHabitsAndHealthStep = () => {
	const { dietaryHabitsAndHealth, setDietaryHabitsAndHealth, application } =
		useFamilyMemberInterviewWizard();

	const { form, mandatoryQuestionsAndAnswersForm } =
		useCategoryFeedbackFormHandling(
			dietaryHabitsAndHealth,
			setDietaryHabitsAndHealth,
			true
		);

	return (
		<CategoryStep
			uiConfig={UiConfig}
			form={form}
			mandatoryQuestionsAndAnswersForm={mandatoryQuestionsAndAnswersForm}
			answers={application?.userAnswers}
		/>
	);
};
